import { Button, Modal } from 'react-bootstrap';
import { useConfiguratorTranslations } from '../translations';
import type { SavedProgress } from '../persistence';

type Props = {
	saved: SavedProgress;
	onContinue: () => void;
	onStartClean: () => void;
};

export function ResumePromptModal({ saved, onContinue, onStartClean }: Props) {
	const tr = useConfiguratorTranslations();
	const readableId = [saved?.progress?.makeLabel, saved?.progress?.modelLabel]
		.filter(Boolean)
		.join(' ');

	return (
		<Modal show backdrop="static" keyboard={false}>
			<Modal.Header>
				<Modal.Title className="fs-5">{tr.resumeTitle}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p className="mb-1">
					{tr.resumeBodyPrefix}{' '}
					<strong style={{ cursor: 'default' }}>
						{tr.resumeLabel(readableId)}
					</strong>
				</p>
				<p className="mb-0">{tr.resumeBodySuffix}</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="link" onClick={onStartClean}>
					{tr.resumeStartClean}
				</Button>
				<Button onClick={onContinue}>{tr.resumeContinue}</Button>
			</Modal.Footer>
		</Modal>
	);
}
